import Vue, { DirectiveOptions } from 'vue'
import * as directives from '@/directives'
import * as filters from '@/filters'
import ElementUI from '@lui/lui-ui'
// 默认蓝色主题
import '@lui/lui-ui/lib/theme-chalk/index.css'
import '@lui/lui-ui/lib/theme-chalk/display.css'
import tracker from '@/utils/tracker'
import App from '@/App.vue'
import store from '@/store'
import router from './router'
import 'babel-polyfill'
import '@/utils/proxy-polyfill'
import i18n from '@/i18n'
import microApp from '@micro-zoe/micro-app'
import urlConfig from '@/views/subapp/urlConfig.js'
import ILUI from '@jdl/il-ui'
import End2End from '@jdl/end2end-track'
// import './pointDelay'
import Cookies from 'js-cookie'

Vue.use(End2End, { i18n: (key: any, value: any) => i18n.t(key, value) })

Vue.use(ILUI, { i18n: (key: any, value: any) => i18n.t(key, value) })

Vue.use(ElementUI, { i18n: (key:any, value:any) => i18n.t(key, value) })

// let lastPointerDownTime = 0
// document.addEventListener('pointerdown', (e) => {
//   lastPointerDownTime = performance.now()
// })

// document.addEventListener('click', (e) => {
//   // @ts-ignore
//   console.log('click', e.target.textContent, e.timeStamp, performance.now())
//   const lastPointerDownTime = e.timeStamp || performance.now()
//   if (lastPointerDownTime) {
//     // 也可以在这里用 requestAnimationFrame 进一步测页面响应
//     // 假设你刚刚做了某个 DOM 操作
//     window.requestIdleCallback(() => {
//       const clickTime = performance.now()
//       const delay = clickTime - lastPointerDownTime
//       // 以防调用逻辑影响业务，切记一定进行catch
//       try {
//         // 其它函数及场景使用介绍
//         const isOK2 = window.__sgm__.business('cINP') // 自定义INP指标
//           .labelNames(['country', 'path'])
//           .labels(['iphone 16', 'pro max'])
//           .setDelay(delay) // 设置订单金额
//           .setMessage('url********') // 设置订单附加描述
//           .submit()
//       } catch (e) {}
//       console.log('pointerdown 到 click 后绘制结束的延迟requestIdleCallback:', delay, 'ms', e)
//     })
//   }
// }, true)

// 方式一：设置数组
// microApp.preFetch([
//   { name: 'tms', url: urlConfig.tms[process.env.VUE_APP_ENV || ''], level: 2 }, // 加载资源并解析
//   { name: '3pl', url: urlConfig.server3pl[process.env.VUE_APP_ENV || ''], level: 2 }, // 只加载资源
//   { name: 'site', url: urlConfig.site[process.env.VUE_APP_ENV || ''], level: 2 }, // 加载资源、解析并渲染
//   { name: 'dms', url: urlConfig.dms[process.env.VUE_APP_ENV || ''], level: 2}, // 加载资源、解析并渲染
// ])
function appendTimestamp(url: string) {
  const t = `time=${Date.now()}`
  return url.includes('?')
    ? `${url}&${t}`
    : `${url}?${t}`
}
/**
 * 子应用加载资源添加重试策略  方式云资源跨域等问题导致子应用打不开
 * @param url
 * @param options
 * @param appName
 * @param maxRetry
 * @param retryDelay
 * @returns
 */
function customFetchWithRetry(url:string, options: any, appName: any, maxRetry = 3, retryDelay = 1000): Promise<string> {
  let isJD = false
  try {
    isJD = new URL(url).hostname.endsWith('jd.com')
  } catch (error) {
    console.log('new URL 异常', url, error)
  }
  // const isJD = new URL(url).hostname.endsWith('jd.com')
  const is3PL = url.includes('3pl')
  const isWL = url.includes('wl.jd.com')
  const devEnvArr = ['yf1', 'pre', 'hollpre', 'yftest']
  let finalOptions = { ...options }
  if (isJD && !is3PL && !isWL && !devEnvArr.includes(process.env.NODE_ENV || '')) {
    finalOptions.credentials = 'include'
  }
  if (url.startsWith('https://jdwfe.s3.cn-north-1.jdcloud-oss.com') || url.startsWith('https://st-eu-cdn.jdl.com/') || url.startsWith('https://st-sg-cdn.jdl.com/') || url.startsWith('https://st-fe-cdn.jdl.com/')) { // && url.indexOf('jdwfe/itms/main') < 0
    url = appendTimestamp(url)
    finalOptions = {
      ...finalOptions,
      mode: 'cors'
    }
  }

  let attempt:number = 0

  function tryFetch(resolve: any, reject: any) {
    const retryUrl = attempt === 0 ? url : appendTimestamp(url) // attempt === 0 ? url :
    window.fetch(retryUrl, finalOptions)
      .then(res => {
        if (!res.ok) throw new Error('HTTP error! status: ' + res.status)
        return res.text()
      })
      .then(text => resolve(text))
      .catch(err => {
        console.log('重试策略生效', err, url)
        attempt++
        if (attempt < maxRetry) {
          setTimeout(() => tryFetch(resolve, reject), retryDelay)
        } else {
          reject(err)
        }
      })
  }

  return new Promise(tryFetch)
}
function getEnvironment() {
  const hostname = window.location.hostname

  switch (hostname) {
    case 'itms.jd.com':
      return 1
    case 'itms-gray.jd.com':
      return 2
    default:
      return 3
  }
}
let envStr = process.env.VUE_APP_ENV || ''
const itmsSite = Cookies.get('itms-site') || 'sg'

if (getEnvironment() === 1) {
  itmsSite === 'eu' && (envStr = 'siteEu')
} else if (getEnvironment() === 2) {
  itmsSite === 'eu' && (envStr = 'siteEuGray')
}
// process.env.VUE_APP_ENV===production gray
console.log('站点信息', itmsSite, getEnvironment(), envStr)
microApp.start({
  prefetchDelay: 5000,
  preFetchApps: [
    { name: 'tms', url: urlConfig.tms[envStr || ''], level: 2 }, // 加载资源并解析
    { name: '3pl', url: urlConfig.server3pl[envStr || ''], level: 2 }, // 只加载资源
    { name: 'site', url: urlConfig.site[envStr || ''], level: 2 }, // 加载资源、解析并渲染
    { name: 'dms', url: urlConfig.dms[envStr || ''], level: 2 } // 加载资源、解析并渲染
  ],
  /**
   * 自定义fetch
   * @param {string} url 静态资源地址
   * @param {object} options fetch请求配置项
   * @param {string|null} appName 应用名称
   * @returns Promise<string>
  */
  // fetch: (url, options, appName) => customFetchWithRetry(url, options, appName, 3, 2000)
  fetch(url, options, appName) {
    const isJD = url.includes('jd.com')
    const is3PL = url.includes('3pl')
    const is3PLGray = url.includes('jx-yf')
    const isWL = url.includes('wl.jd.com')
    const isRestapi = url.includes('restapi.amap.com')
    const devEnvArr = ['yf1', 'pre', 'hollpre']
    // 复制 options，避免污染原对象
    let finalOptions = { ...options }
    if (isJD && !isRestapi && !is3PL && !isWL && !devEnvArr.includes(process.env.NODE_ENV || '')) {
      finalOptions.credentials = 'include'
    } else if (is3PLGray) {
      finalOptions.credentials = 'include'
    }// https://storage.jd.co.th https:// print-web.s3.cn-north-1.jdcloud-oss.com/message-outreach/pc-sdk-prod.js
    if ((url.startsWith('https://storage.jd.co.th') || url.startsWith('https:// print-web.s3.cn-north-1.jdcloud-oss.com') || url.startsWith('https://jdwfe.s3.cn-north-1.jdcloud-oss.com'))) { //  && url.indexOf('jdwfe/itms/main') < 0
      // 添加 mode: 'cors' 参数
      finalOptions = {
        ...finalOptions,
        mode: 'cors'
      }
    }
    return window.fetch(url, finalOptions).then(res => res.text())
  }
})

// 注册自定义标签 [如按钮权限控制]
// Object.keys(directives).forEach((key) => {
//   Vue.directive(key, (directives as { [key: string ]: DirectiveOptions })[key])
// })

// 注册过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, (filters as { [key: string ]: Function })[key])
})

Vue.config.productionTip = false

Vue.config.devtools = true
Vue.prototype.$tracker = tracker

window.eventHub = new Vue()
window.router = router
new Vue({
  i18n,
  router,
  store,
  render: (h: (arg0: any) => any) => h(App)
}).$mount('#app')
